import { teamEmailAddressSchema } from "@redotech/redo-marketing-core-common/email/domain-verification";
import * as z from "zod";

export const updateCustomDomainEmailSettings = {
  name: "updateCustomDomainEmailSettings" as const,
  input: z.object({
    addresses: z.array(teamEmailAddressSchema.omit({ id: true })).optional(),
    defaultFromAddressId: z.string().nullish(),
    defaultReplyToAddressId: z.string().nullish(),
  }),
  output: z.object({ message: z.string() }),
};
